var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-reviews",class:['l-container']},[_c('div',{staticClass:"nosto_page_type",staticStyle:{"display":"none"}},[_vm._v("\n    other\n  ")]),_vm._v(" "),_c('hero-banner',{attrs:{"type":"ShortHero","title":"Reviews"}}),_vm._v(" "),_c('reviews-widget')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }